import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Login from "../pages/Login";
import PageNotFound from "../pages/404";
import PrivateRoute from "../components/auth/PrivateRoutes";
import { ROLES, LAYOUT } from "../constant/constant";

import { Modules, ModuleMenu } from "../pages/modules";
import { User, UserAccess, UserManage } from "../pages/user";
import { PermissionAccess } from "../pages/permission";

import { ProjectPage, ProjectAccess, ProjectManage, ProjectView } from "../pages/support/project";
import { SelectionPage, SelectionAccess, SelectionManage, SelectionPrint } from "../pages/support/selection";
import CustomerPage from "../pages/support/customer/CustomerPage";
import { RcPage, RcAccess, RcView } from "../pages/support/rc";
import { PortalLayout, PortalLogin, PortalHome, PortalProject, PortalRc } from "../portal";
import HouseModelPage from "../pages/master/house-model/HouseModelPage";
import MaterialPage from "../pages/master/material/MaterialPage";
import MaterialCategoryPage from "../pages/master/material-category/MaterialCategoryPage";
import EmployeePage from "../pages/master/employee/EmployeePage";
import { TemplatePage, TemplateAccess, TemplateManage } from "../pages/master/template";

const Router = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Navigate replace to="/login" />} />
        <Route path="/login" element={<Login />} />

        {/* ---------- ลูกค้า (portal) — login ที่ /login เดียวกับพนักงาน ระบบพามาที่นี่ ---------- */}
        <Route path="/portal/login" element={<PortalLogin />} /> {/* ลิงก์เก่า → /login */}
        <Route path="/portal" element={<PortalLayout />}>
          <Route index element={<PortalHome />} />
          <Route path="project/:code" element={<PortalProject />} />
          <Route path="rc/:code" element={<PortalRc />} />
        </Route>

        <Route element={<PrivateRoute allowdRole={[ROLES.ADMIN, ROLES.USER]} />}>
          <Route path="/modules" element={<Modules />} />
          <Route path="/modules/:key" element={<ModuleMenu />} />

          {/* ---------- Support ---------- */}
          <Route path="/support/project" element={<ProjectPage />}>
            <Route index element={<ProjectAccess />} />
            <Route path="manage/:code" element={<ProjectManage />} />
            <Route path="view/:code" element={<ProjectView />} />
          </Route>
          <Route path="/support/selection" element={<SelectionPage />}>
            <Route index element={<SelectionAccess />} />
            <Route path="manage/:code" element={<SelectionManage />} />
          </Route>
          <Route path="/support/rc" element={<RcPage />}>
            <Route index element={<RcAccess />} />
            <Route path="view/:code" element={<RcView />} />
          </Route>
          <Route path="/support/customer" element={<CustomerPage />} />

          {/* ---------- Master ---------- */}
          <Route path="/master/house-model" element={<HouseModelPage />} />
          <Route path="/master/material" element={<MaterialPage />} />
          <Route path="/master/material-category" element={<MaterialCategoryPage />} />
          <Route path="/master/employee" element={<EmployeePage />} />
          <Route path="/master/template" element={<TemplatePage />}>
            <Route index element={<TemplateAccess />} />
            <Route path="manage/:code" element={<TemplateManage />} />
          </Route>
        </Route>

        <Route element={<PrivateRoute allowdRole={[ROLES.ADMIN]} />}>
          <Route path="/user/" element={<User />}>
            <Route index element={<UserAccess />} />
            <Route path="manage/:action" element={<UserManage />} />
          </Route>
          <Route path="/permission" element={<PermissionAccess />} />
        </Route>

        {/* หน้าพิมพ์ ไม่มีเมนู */}
        <Route element={<PrivateRoute allowdRole={[ROLES.ADMIN, ROLES.USER]} layout={LAYOUT.ALOND} />}>
          <Route path="/print/selection/:code" element={<SelectionPrint />} />
        </Route>

        <Route path="/*" element={<PageNotFound />} />
      </Routes>
    </BrowserRouter>
  );
};

export default Router;
